import {Button} from '@yandex-delivery/blocks'
import {Drawer, DrawerSection, Input, InputVariants} from '@yandex-delivery/blocks/legacy'
import React, {useCallback, useState} from 'react'
import i18n from 'src/shared/i18n'

import {classes} from './CommentMobile.styles'

type Props = {
  comment?: string
  onSubmit: (newComment?: string) => void
  onClose: VoidFunction
}

const CommentMobile: React.FC<Props> = ({comment, onSubmit, onClose}) => {
  const [newComment, setNewComment] = useState<string | undefined>(comment)
  const handleCommentChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(event => {
    setNewComment(event.target.value)
  }, [])
  const handleSubmitClick = useCallback(() => onSubmit(newComment), [newComment, onSubmit])

  return (
    <Drawer data-feedback-drawer expanderType="outside" maxHeight={200} onClose={onClose}>
      <DrawerSection fullHeight>
        <div className={classes.wrapper} data-e2e="modal-feedback-delivery">
          <div className={classes.title}>{i18n.print('route_feedback')}</div>
          <Input
            className={classes.input}
            clearable={false}
            data-e2e="input-feedback-delivery"
            onChange={handleCommentChange}
            placeholder={i18n.print('route_feedback_comment')}
            value={newComment}
            variant={InputVariants.Line}
          />
          <Button
            className={classes.button}
            data-e2e="button-save"
            fullWidth
            onPress={handleSubmitClick}
            variant="action"
          >
            {i18n.print('route_feedback_done')}
          </Button>
        </div>
      </DrawerSection>
    </Drawer>
  )
}

export default CommentMobile
